<template>
  <div id="main-map-container">
    <button @click="back" class="back" v-show="chartStack.length > 1">
      返回
    </button>
    <div id="tc-map" :style="`height:${height}px;width:${width}px;`"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import longYangJson from "./test2.js";
import yuanquJson from "./yuanqu.js";
import yuanqu2Json from "./yuanqu2.js";
import { url } from "@/config.js";
import { levelFirstList, levelThirdList } from "./levelList";
export default {
  name: "flyLine",
  props: {
    option: {
      default: null,
    },
    id: {
      default: null,
    },
    height: {
      default: 0,
    },
    width: {
      default: 0,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initMap();
    });
  },
  data() {
    return {
      myChart: null,
      level: 0,
      chartStack: [],
    };
  },
  watch: {
    option: {
      handler(val) {
        this.setMap(val);
      },
      deep: true,
    },
  },
  methods: {
    initMap() {
      this.myChart = echarts.init(document.getElementById("tc-map"));
      window.refs = this.$parent.$parent.$refs;
      try {
        this.$parent.$parent.$refs[
          "listc93c5366-0442-4cd2-8505-f027d0a386df"
        ][0].active = "1";
        this.$parent.$parent.$refs[
          "listb7d87025-04c1-4f42-b6a5-fa201008d279"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "list15b3d635-4521-47cc-a70f-6a584e3ce131"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "list92bfae40-9fc2-4ac4-8eb7-408055d3bf50"
        ][0].$el.style.display = "none";
        this.$parent.$parent.$refs[
          "list8151935a-a1b9-4c3c-b44b-d07497c8d5bc"
        ][0].$el.style.display = "none";
        this.$parent.$parent.$refs[
          "listb171968d-73b2-4b80-b9ef-3b77d9ceec74"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "list9dba0026-94ca-46ab-8212-f2cd28abdeb6"
        ][0].$el.style.display = "none";
        this.$parent.$parent.$refs[
          "list7e1f7ca6-033c-4001-8999-4d2e1cfc45b1"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "list4c9394e2-308d-40b5-b977-e6bb4147148b"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "listec67118a-9de4-4afe-8430-ed3c6e6251ff"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "list7401bd86-cdbf-44cd-8aeb-555f698ac347"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "list7401bd86-cdbf-44cd-8aeb-555f698ac347"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "listb39979fc-c6a2-46f5-8f47-44b7261f7304"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "list801b8bf1-ee4d-4014-9ffd-3449df24ab66"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "list27326da0-1e8c-4c00-8ba8-63409d4ef6ae"
        ][0].$el.style.display = "none";
        this.$parent.$parent.$refs[
          "listb0081e9a-5684-4a40-8ee1-729c7bb84b3a"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "listc2d500f6-593a-4974-8ac2-2df4b0510024"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "listd80542eb-7f87-40b2-8446-217f3d4901ba"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "list5732ff47-4fd3-44cd-8c46-d6d48d771669"
        ][0].$el.style.display = "none";
        this.$parent.$parent.$refs[
          "list54235926-dc49-454b-a193-9c48ec084ed4"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "list01bb0c70-2d1c-4c59-86a0-cf34ea099798"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "list9bd24ee2-b60b-488c-bb78-d894bcf0319d"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "list319991fa-9f91-4d41-8902-f22242923a50"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "list37fe3a52-6e3a-4b89-86d9-ade12562761d"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "list4a65b49f-4ff6-43a9-bcf4-e04394dd3ccf"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "list07fb8fa7-3809-446d-8ab9-375e670084b8"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "list411b5a2c-973d-484b-b36e-05178b6fae4b"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "listb199b10a-ebcc-4263-89e2-dddb6c317f04"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "list296d9285-9b3a-4804-b79d-924dfc4e00a9"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "listb0081e9a-5684-4a40-8ee1-729c7bb84b3a"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "list39bbc3e7-6df9-4893-a6b6-85bfdc32e100"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "list452560b7-712c-40e7-93da-18c9f403c111"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "list736bd645-09a4-4fbd-bd0b-63d756fc013d"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "listf252f1de-2c0b-4dae-824e-a36fa8eac828"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "listf9b3d9df-cf7e-488d-b36a-b2339c0b2325"
        ][0].$el.style.display = "none";
        this.$parent.$parent.$refs[
          "list49c9a1bc-0bc6-4db9-8500-05a8e6ebf314"
        ][0].$el.style.display = "none";
        this.$parent.$parent.$refs[
          "listac640e83-8d4a-4218-8ef3-75b82da812a0"
        ][0].$el.style.display = "none";
        this.$parent.$parent.$refs[
          "list3dc3d8db-ec59-4e17-9215-8dacb08f0b76"
        ][0].$el.style.display = "none";
        this.$parent.$parent.$refs[
          "list5fd62d44-ff45-4dcc-8feb-b9d1d50965f2"
        ][0].$el.style.display = "none";
        this.$parent.$parent.$refs[
          "list08eef2cf-5f45-47a8-89f4-c547359fdae8"
        ][0].$el.style.display = "none";
        this.$parent.$parent.$refs[
          "list09dedbfb-30b5-41ee-80d4-ad9710e1e2f8"
        ][0].$el.style.display = "none";
        this.$parent.$parent.$refs[
          "listf83c6214-2fb1-4ac0-84f3-dae7aff347f9"
        ][0].$el.style.display = "none";
        this.$parent.$parent.$refs[
          "listcf5b4303-de99-4c9e-826b-3fe98b3be7f8"
        ][0].$el.style.display = "none";
        this.$parent.$parent.$refs[
          "list9ce8840c-b095-44df-8f08-eed418ebd1de"
        ][0].$el.style.display = "none";
        this.$parent.$parent.$refs[
          "list8cbb2dd8-08ff-4fa7-977d-eb03df342dd9"
        ][0].$el.style.display = "none";
        this.$parent.$parent.$refs[
          "list03fc35d4-5c5b-4a84-8504-6e6400b845ca"
        ][0].$el.style.display = "none";
        this.$parent.$parent.$refs[
          "liste7eff2e2-b681-4649-8142-7e697cf85256"
        ][0].$el.style.display = "none";
        this.$parent.$parent.$refs[
          "listc776d39e-1fcf-427a-82b1-9542f341bbb1"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "list46074972-9127-4e82-854b-820fccd14168"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "list7ebd0557-bd63-4c28-8af3-cf4d91999e95"
        ][0].$el.style.display = "block";
        this.$parent.$parent.$refs[
          "listfe389307-11d3-4efa-8ed3-5379e9bdc6b0"
        ][0].$el.style.display = "none";
      } catch (error) {}
      this.setMap(this.option);
    },
    echartsMapClick(params) {
      if (this.chartStack.length === 1) {
        echarts.registerMap(`${this.option.mapData}`, yuanquJson);
        this.chartStack.push(yuanquJson);
        // //渲染地图
        this.myChart.clear();
        this.myChart.setOption(this.getOptio2(this.option));
        try {
          this.$parent.$parent.$refs[
            "listc93c5366-0442-4cd2-8505-f027d0a386df"
          ][0].active = "2";
          this.$parent.$parent.$refs[
            "listb7d87025-04c1-4f42-b6a5-fa201008d279"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list15b3d635-4521-47cc-a70f-6a584e3ce131"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list92bfae40-9fc2-4ac4-8eb7-408055d3bf50"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list8151935a-a1b9-4c3c-b44b-d07497c8d5bc"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list452560b7-712c-40e7-93da-18c9f403c111"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "listb0081e9a-5684-4a40-8ee1-729c7bb84b3a"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list39bbc3e7-6df9-4893-a6b6-85bfdc32e100"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "listb171968d-73b2-4b80-b9ef-3b77d9ceec74"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list9dba0026-94ca-46ab-8212-f2cd28abdeb6"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list7e1f7ca6-033c-4001-8999-4d2e1cfc45b1"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list4c9394e2-308d-40b5-b977-e6bb4147148b"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "listec67118a-9de4-4afe-8430-ed3c6e6251ff"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list7401bd86-cdbf-44cd-8aeb-555f698ac347"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list7401bd86-cdbf-44cd-8aeb-555f698ac347"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "listb39979fc-c6a2-46f5-8f47-44b7261f7304"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list801b8bf1-ee4d-4014-9ffd-3449df24ab66"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list27326da0-1e8c-4c00-8ba8-63409d4ef6ae"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "listc2d500f6-593a-4974-8ac2-2df4b0510024"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "listd80542eb-7f87-40b2-8446-217f3d4901ba"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list5732ff47-4fd3-44cd-8c46-d6d48d771669"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list54235926-dc49-454b-a193-9c48ec084ed4"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list01bb0c70-2d1c-4c59-86a0-cf34ea099798"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list9bd24ee2-b60b-488c-bb78-d894bcf0319d"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list319991fa-9f91-4d41-8902-f22242923a50"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list37fe3a52-6e3a-4b89-86d9-ade12562761d"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list4a65b49f-4ff6-43a9-bcf4-e04394dd3ccf"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list07fb8fa7-3809-446d-8ab9-375e670084b8"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list411b5a2c-973d-484b-b36e-05178b6fae4b"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "listb199b10a-ebcc-4263-89e2-dddb6c317f04"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list296d9285-9b3a-4804-b79d-924dfc4e00a9"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list07fb8fa7-3809-446d-8ab9-375e670084b8"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list411b5a2c-973d-484b-b36e-05178b6fae4b"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "listb199b10a-ebcc-4263-89e2-dddb6c317f04"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list296d9285-9b3a-4804-b79d-924dfc4e00a9"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list736bd645-09a4-4fbd-bd0b-63d756fc013d"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "listf252f1de-2c0b-4dae-824e-a36fa8eac828"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list9ce8840c-b095-44df-8f08-eed418ebd1de"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list8cbb2dd8-08ff-4fa7-977d-eb03df342dd9"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list03fc35d4-5c5b-4a84-8504-6e6400b845ca"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "liste7eff2e2-b681-4649-8142-7e697cf85256"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "listf9b3d9df-cf7e-488d-b36a-b2339c0b2325"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list49c9a1bc-0bc6-4db9-8500-05a8e6ebf314"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "listac640e83-8d4a-4218-8ef3-75b82da812a0"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list3dc3d8db-ec59-4e17-9215-8dacb08f0b76"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list5fd62d44-ff45-4dcc-8feb-b9d1d50965f2"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list08eef2cf-5f45-47a8-89f4-c547359fdae8"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list09dedbfb-30b5-41ee-80d4-ad9710e1e2f8"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "listf83c6214-2fb1-4ac0-84f3-dae7aff347f9"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "listcf5b4303-de99-4c9e-826b-3fe98b3be7f8"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "listc776d39e-1fcf-427a-82b1-9542f341bbb1"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list46074972-9127-4e82-854b-820fccd14168"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list7ebd0557-bd63-4c28-8af3-cf4d91999e95"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "listfe389307-11d3-4efa-8ed3-5379e9bdc6b0"
          ][0].$el.style.display = "none";
        } catch (error) {}
      } else if (this.chartStack.length === 2) {
        try {
          const instance =
            this.$parent.$parent.$refs[
              "listc93c5366-0442-4cd2-8505-f027d0a386df"
            ][0];
          instance.setData(params.name);
          console.log("-------", params.name);
          console.log("-------", instance);
          console.log("-------", instance.setData);
        } catch (error) {}
      }
    },
    getOption(option) {
      let mapRadarData = [];
      if (this.option.mapRadarData) {
        try {
          mapRadarData = JSON.parse(
            this.option.mapRadarData
              .replace(/[\r\n]/g, "")
              .replace(/\s*/g, "")
              .replaceAll("},]", "}]")
              .replaceAll("],]", "]]")
          );
        } catch (err) {}
      }
      let obj = {
        geo: [
          {
            name: "map1",
            type: "map",
            map: `${option.mapData}`,
            id: "map1",
            zlevel: 1,
            itemStyle: {
              areaColor: "#4672c9",
              borderColor: "#5b90dd",
              borderWidth: 2,
              shadowColor: `#022e58`,
              shadowOffsetX: 3,
              shadowOffsetY: 6,
              shadowBlur: 1,
            },
            label: {
              show: false,
            },
            aspectScale: 0.9,
            zoom: 1.2, //默认显示级别
            scaleLimit: {
              min: 0,
              max: 3,
            },
          },
        ],
        series: [
          {
            name: "map1",
            type: "map",
            map: `${option.mapData}`,
            zoom: 1.2, //默认显示级别
            scaleLimit: {
              min: 0,
              max: 3,
            },
            id: "map1",
            zlevel: 3,
            itemStyle: {
              areaColor: option.areaColor,
              borderColor: option.borderColor,
              borderWidth: option.borderWidth,
            },
            label: {
              show: true,
              color: option.color,
              fontSize: "12px" || option.fontSize,
            },
            emphasis: {
              itemStyle: {
                areaColor: option.empAreaColor,
              },
              label: {
                color: option.empBorderColor,
              },
            },
            select: {
              itemStyle: {
                areaColor: option.empAreaColor,
              },
              label: {
                color: option.empBorderColor,
              },
            },
            aspectScale: 0.9,
            tooltip: {
              show: true,
            },
          },
        ],
        tooltip: {
          trigger: "item",
          formatter: (data) => {
            return `${data.name}`;
          },
          backgroundColor: this.option.mapTooltipSlideBackColor || "#15c8f6",
          textStyle: {
            fontSize: 30,
            color: this.option.mapTooltipSlideTextColor || "#ffffff",
          },
        },
      };
      return obj;
    },
    getOptio2(option) {
      let mapRadarData = [];
      if (this.option.mapRadarData) {
        try {
          mapRadarData = JSON.parse(
            this.option.mapRadarData
              .replace(/[\r\n]/g, "")
              .replace(/\s*/g, "")
              .replaceAll("},]", "}]")
              .replaceAll("],]", "]]")
          );
        } catch (err) {}
      }

      let obj = {
        geo: [
          {
            name: "map1",
            type: "map",
            map: `${option.mapData}`,
            id: "map1",
            zlevel: 1,
            itemStyle: {
              areaColor: "#4672c9",
              borderColor: "#5b90dd",
              borderWidth: 2,
              shadowColor: `#022e58`,
              shadowOffsetX: 3,
              shadowOffsetY: 6,
              shadowBlur: 1,
            },
            label: {
              show: false,
            },
            aspectScale: 0.9,
            zoom: 1.2, //默认显示级别
            scaleLimit: {
              min: 0,
              max: 3,
            },
          },
        ],
        series: [
          {
            name: "map1",
            type: "map",
            map: `${option.mapData}`,
            zoom: 1.2, //默认显示级别
            scaleLimit: {
              min: 0,
              max: 3,
            },
            id: "map1",
            zlevel: 3,
            itemStyle: {
              //  'transparent' ||
              areaColor: option.areaColor,
              borderColor: option.borderColor,
              borderWidth: option.borderWidth,
            },
            label: {
              show: false,
              color: option.color,
              fontSize: "12px" || option.fontSize,
            },
            emphasis: {
              itemStyle: {
                areaColor: option.empAreaColor,
              },
              label: {
                color: option.empBorderColor,
              },
            },
            select: {
              itemStyle: {
                areaColor: option.empAreaColor,
              },
              label: {
                color: option.empBorderColor,
              },
            },
            aspectScale: 0.9,
            tooltip: {
              show: true,
            },
          },
        ],
        tooltip: {
          trigger: "item",
          formatter: (data) => {
            return `${data.name}`;
          },
          backgroundColor: this.option.mapTooltipSlideBackColor || "#15c8f6",
          textStyle: {
            fontSize: 30,
            color: this.option.mapTooltipSlideTextColor || "#ffffff",
          },
        },
      };
      return obj;
    },
    setMap(option) {
      //获取地图数据
      let _this = this;
      axios
        .get(`${option.mapData.replace("/visual-api/", "")}`)
        .then(function (response) {
          // console.log(response.data.features);
          response.data.features.shift();
          response.data.features = [
            ...response.data.features,
            ...longYangJson.features,
          ];
          console.log(response.data.features);
          echarts.registerMap(`${option.mapData}`, response.data);
          _this.chartStack.push(response.data);
          _this.myChart.clear();
          _this.myChart.on("click", _this.echartsMapClick);
          _this.myChart.setOption(_this.getOption(option));
          _this.myChart.dispatchAction({
            type: "highlight", // 高亮指定的数据图形。通过seriesName或者seriesIndex指定系列。如果要再指定某个数据可以再指定dataIndex或者name。
            seriesIndex: 0,
            name: "隆阳区",
          });
        });
    },
    back() {
      if (this.chartStack.length === 1) {
      } else {
        this.chartStack.pop();
        echarts.registerMap(
          `${this.option.mapData}`,
          this.chartStack[this.chartStack.length - 1]
        );
        this.myChart.clear();
        this.myChart.setOption(this.getOption(this.option));
        try {
          this.$parent.$parent.$refs[
            "listc93c5366-0442-4cd2-8505-f027d0a386df"
          ][0].active = "1";
          this.$parent.$parent.$refs[
            "listb7d87025-04c1-4f42-b6a5-fa201008d279"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list15b3d635-4521-47cc-a70f-6a584e3ce131"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list92bfae40-9fc2-4ac4-8eb7-408055d3bf50"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list8151935a-a1b9-4c3c-b44b-d07497c8d5bc"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "listb171968d-73b2-4b80-b9ef-3b77d9ceec74"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list9dba0026-94ca-46ab-8212-f2cd28abdeb6"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list7e1f7ca6-033c-4001-8999-4d2e1cfc45b1"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list4c9394e2-308d-40b5-b977-e6bb4147148b"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "listec67118a-9de4-4afe-8430-ed3c6e6251ff"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list7401bd86-cdbf-44cd-8aeb-555f698ac347"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list7401bd86-cdbf-44cd-8aeb-555f698ac347"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "listb39979fc-c6a2-46f5-8f47-44b7261f7304"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list801b8bf1-ee4d-4014-9ffd-3449df24ab66"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list27326da0-1e8c-4c00-8ba8-63409d4ef6ae"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "listb0081e9a-5684-4a40-8ee1-729c7bb84b3a"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "listc2d500f6-593a-4974-8ac2-2df4b0510024"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "listd80542eb-7f87-40b2-8446-217f3d4901ba"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list5732ff47-4fd3-44cd-8c46-d6d48d771669"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list54235926-dc49-454b-a193-9c48ec084ed4"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list01bb0c70-2d1c-4c59-86a0-cf34ea099798"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list9bd24ee2-b60b-488c-bb78-d894bcf0319d"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list319991fa-9f91-4d41-8902-f22242923a50"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list37fe3a52-6e3a-4b89-86d9-ade12562761d"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list4a65b49f-4ff6-43a9-bcf4-e04394dd3ccf"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list07fb8fa7-3809-446d-8ab9-375e670084b8"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list411b5a2c-973d-484b-b36e-05178b6fae4b"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "listb199b10a-ebcc-4263-89e2-dddb6c317f04"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list296d9285-9b3a-4804-b79d-924dfc4e00a9"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "listb0081e9a-5684-4a40-8ee1-729c7bb84b3a"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list39bbc3e7-6df9-4893-a6b6-85bfdc32e100"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list452560b7-712c-40e7-93da-18c9f403c111"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list736bd645-09a4-4fbd-bd0b-63d756fc013d"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "listf252f1de-2c0b-4dae-824e-a36fa8eac828"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "listf9b3d9df-cf7e-488d-b36a-b2339c0b2325"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list49c9a1bc-0bc6-4db9-8500-05a8e6ebf314"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "listac640e83-8d4a-4218-8ef3-75b82da812a0"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list3dc3d8db-ec59-4e17-9215-8dacb08f0b76"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list5fd62d44-ff45-4dcc-8feb-b9d1d50965f2"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list08eef2cf-5f45-47a8-89f4-c547359fdae8"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list09dedbfb-30b5-41ee-80d4-ad9710e1e2f8"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "listf83c6214-2fb1-4ac0-84f3-dae7aff347f9"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "listcf5b4303-de99-4c9e-826b-3fe98b3be7f8"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list9ce8840c-b095-44df-8f08-eed418ebd1de"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list8cbb2dd8-08ff-4fa7-977d-eb03df342dd9"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "list03fc35d4-5c5b-4a84-8504-6e6400b845ca"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "liste7eff2e2-b681-4649-8142-7e697cf85256"
          ][0].$el.style.display = "none";
          this.$parent.$parent.$refs[
            "listc776d39e-1fcf-427a-82b1-9542f341bbb1"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list46074972-9127-4e82-854b-820fccd14168"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "list7ebd0557-bd63-4c28-8af3-cf4d91999e95"
          ][0].$el.style.display = "block";
          this.$parent.$parent.$refs[
            "listfe389307-11d3-4efa-8ed3-5379e9bdc6b0"
          ][0].$el.style.display = "none";
        } catch (error) {}
      }
    },
  },
};
</script>

<style type="text/css">
.back {
  position: absolute;
  left: 35%;
  top: 3%;
  z-index: 3;
  color: rgb(17, 221, 237);
  font-size: 15px;
  border-radius: 4px;
  border-color: rgb(17, 221, 237);
  background-color: transparent;
  width: 108px;
  height: 42px;
}
.point {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: red;
  position: absolute;
  left: 51.5%;
  top: 55%;
  z-index: 10;
}

#tc-map {
  position: absolute;
  top: 80px;
  left: -20px;
  z-index: 2;
}
#tc-map {
  position: relative;
}
#main-map-container,
#tc-map > div:first-child {
  position: absolute !important;
  width: 100% !important;
  height: 100% !important;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
#tc-map > div:last-child {
  /* min-width: 400px !important; */
}
#tc-map > div canvas {
  position: absolute !important;
  width: 100% !important;
  height: 100% !important;
}
</style>
